var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "contact-information" }, [
    _c("div", { staticClass: "row header" }, [
      _c("div", { staticClass: "col-12 mb-3 mt-2" }, [
        _c("em", {
          staticClass:
            "fas rounded-circle p-1 mr-2 color-green shadow bg-white",
          class: _vm.editModel.isNew ? "fa-plus" : "fa-edit"
        }),
        _c("span", [
          _vm._v(
            " " +
              _vm._s(_vm.editModel.isNew ? "Añadir" : "Editar") +
              " Contacto " +
              _vm._s(_vm.editModel.isPrimary ? "Primario" : "Secundario") +
              " "
          )
        ])
      ])
    ]),
    _c("div", { staticClass: "row body" }, [
      _c("div", { staticClass: "col" }, [
        _c(
          "div",
          { staticClass: "col-xs-12" },
          [
            _c(
              "validation-observer",
              { ref: "formValidator" },
              [
                _c("contact-information", {
                  attrs: { "civil-statuses": _vm.civilStatuses },
                  model: {
                    value: _vm.editModel,
                    callback: function($$v) {
                      _vm.editModel = $$v
                    },
                    expression: "editModel"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("div", { staticClass: "col-xs-12" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-12 col-md-6" },
              [
                _c("check-box", {
                  staticClass: "mb-2",
                  attrs: {
                    disabled:
                      _vm.disablePrimary || _vm.isPrimaryInitiallySelected,
                    text: "Primario"
                  },
                  model: {
                    value: _vm.editModel.isPrimary,
                    callback: function($$v) {
                      _vm.$set(_vm.editModel, "isPrimary", $$v)
                    },
                    expression: "editModel.isPrimary"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-sm-12 col-md-6 text-right pt-3" },
              [
                _c("action-button", {
                  staticClass: "mr-2 py-2 w-18 btnCancel",
                  attrs: {
                    i: "fas fa-times-circle",
                    text: "Cancelar",
                    variant: "outline-danger"
                  },
                  on: { click: _vm.cancel }
                }),
                _c("action-button", {
                  staticClass: "py-2 w-17",
                  attrs: {
                    i: "fas fa-save",
                    text: "Guardar",
                    variant: "success"
                  },
                  on: { click: _vm.save }
                })
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }